import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataService } from 'src/app/shared/services/data.service';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Action_SetCurrentApplication } from '../state/actions';
import { Router } from '@angular/router';
import { ErrorResponse } from 'src/app/shared/models/error.model';

@Component({
  selector: 'online-app-parents-validation',
  templateUrl: './parents-validation.component.html',
  styleUrls: ['./parents-validation.component.scss']
})
export class ParentsValidationComponent implements OnInit {

  parentsValidationFormGroup: FormGroup;
  isFormSubmitted: Boolean = false;
  studentGivenName = '';
  studentFamilyName = '';
  studentDateOfBirth = '';
  studentNationality = '';

  parentsValidationErrorMsg = '';

  studentValidationDetailsSubscription: Subscription;

  constructor(private formBuilder: FormBuilder,
              private store: Store<any>,
              private router: Router,
              private dataService: DataService) { }

  ngOnInit() {

    this.parentsValidationFormGroup = this.formBuilder.group({
      fatherGivenName: ['', Validators.required],
      fatherFamilyName: ['', Validators.required],
      motherGivenName: ['', Validators.required],
      motherFamilyName: ['', Validators.required],
    });

    this.studentValidationDetailsSubscription =
            this.store.pipe(select('application'))
                .subscribe( applicationState => {

                  if (applicationState && applicationState.studentValidationDetails) {

                    const { StudentGivenName,
                            StudentFamilyName,
                            StudentDateOfBirth,
                            StudentNationality } = applicationState.studentValidationDetails;

                    this.studentGivenName = StudentGivenName;
                    this.studentFamilyName = StudentFamilyName;
                    this.studentDateOfBirth = StudentDateOfBirth;
                    this.studentNationality = StudentNationality;
                  }

              });

  }

  cancelParentsValidation(): void {
    this.router.navigate(['/applications', 'dashboard']);
  }

  validateParentsInfo(): void {

    this.isFormSubmitted = true;

    if (this.parentsValidationFormGroup.valid) {

      const studentGivenName = this.studentGivenName;
      const studentFamilyName = this.studentFamilyName;
      const studentDateOfBirth = this.studentDateOfBirth;
      const studentCountryCode = this.studentNationality;

      const fatherGivenName = this.parentsValidationFormGroup.get('fatherGivenName').value;
      const fatherFamilyName = this.parentsValidationFormGroup.get('fatherFamilyName').value;
      const motherGivenName = this.parentsValidationFormGroup.get('motherGivenName').value;
      const motherFamilyName = this.parentsValidationFormGroup.get('motherFamilyName').value;

      this.dataService.ValidateStudentParentsInfo(studentGivenName, studentFamilyName, studentDateOfBirth,
                        studentCountryCode, fatherGivenName, fatherFamilyName,
                        motherGivenName, motherFamilyName)
      .subscribe(
        (response: SingleResultApiResponse) => {

          if (response.Errors && response.Errors.length > 0) {
            //console.log(`Error: ${response.Errors}`);
          } else {
            this.parentsValidationErrorMsg = '';
            const applicationId = response.Result.ApplicationId;
            const customerReferenceNumber = response.Result.CustomerReferenceNumber;

            this.store.dispatch({
              type: Action_SetCurrentApplication,
              payload: applicationId
            });

            this.router.navigate(['/applications', applicationId, 'edit', 'important-information']);
          }

        },
        (errorResponse: ErrorResponse) => {
          const errors = errorResponse.errors;
          if (errors && errors.length > 0) {
            const errorKey = errors[0].Key;
            const errorValue = errors[0].Value;
            if (errorKey === 'model') {
              this.parentsValidationErrorMsg = errorValue;
            }
        }}
      );

    }

  }

}
